import { alpha, IconButton, Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { Bell, Trash2 } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import {
	getReminderRecurrenceLabel,
	type ReminderEntry,
} from "web_myplann/Shared/Utils/reminder";

type Props = {
	reminder: ReminderEntry;
	highlighted?: boolean;
	onRemove: () => void;
};

export const ReminderRow: FC<Props> = ({
	reminder,
	highlighted = false,
	onRemove,
}) => {
	const { palette } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.4}
			px={1.6}
			py={1.2}
			borderBottom={`1px solid ${palette.surface.border}`}
			bgcolor={highlighted ? alpha(palette.blue[50], 0.7) : undefined}
		>
			<IconBox bg={palette.blue[50]} size={32}>
				<Bell size={16} color={palette.blue[600]} />
			</IconBox>
			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyMedium">
					{t(Resources.Reminder.until, {
						date: dayjs(reminder.date).format("D. M. YYYY"),
					})}
				</Typography>
				<Typography variant="hint">
					{t(getReminderRecurrenceLabel(reminder.recurrence))}
				</Typography>
			</Stack>
			<IconButton variant="ghost" onClick={onRemove}>
				<Trash2 size={16} color={palette.grey[400]} />
			</IconButton>
		</Stack>
	);
};
